export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/collapse/index.ts